Wizard = function(container){
	this.container = $(container);
	this.closeThis = $('#chooseWizard .j-close-popup');
	this.wizardCircle = this.container.find('.js-wizard-step');
	this.wizardPage = this.container.find('.js-wizard-page');
	this.wizardNext = this.container.find('.js-wizard-next');
	this.wizardCurrent = 0;
	this.wizardAnswer = '';
	this.wizardVat = this.container.parent().find('.js-wizard-vat-trigger');
	this.wizardVatClose = this.container.parent().find('.js-wizard-vat-close');

	this.congrats = $('#congrats');
	this.congratsLink = $('.js-congrats');
	this.congratsVariants = this.congrats.find('.js-congrats-variant');

	this.init();
};

Wizard.prototype.init = function(){
	var cmp = this;

	$(cmp.wizardCircle[cmp.wizardCurrent]).addClass('_current');
	$(cmp.wizardPage[cmp.wizardCurrent]).show();

	cmp.closeThis.on('click', function(){
		cmp.wizardPage.removeAttr('style');
		$(cmp.wizardPage[0]).show();
		cmp.wizardCircle.removeClass('_answered')
			.removeClass('_current');
		$(cmp.wizardCircle[0]).addClass('_current');
		cmp.wizardCurrent = 0;
		cmp.wizardAnswer = '';
	});

	cmp.wizardNext.on('click', function(e){
		e.preventDefault();
		var radio = $(cmp.wizardPage[cmp.wizardCurrent]).find('input[type="radio"]');
		var boolka = false;
		for(var i=0; i<radio.length; i++){
			if($(radio[i]).is(':checked')){
				boolka = true;
			}
		}
		if(boolka){
			switch(cmp.wizardCurrent){
				case 0:{
					if($('#question1a').is(':checked')){
						$(cmp.wizardPage).hide();
						$(cmp.wizardPage[cmp.wizardCurrent+1]).fadeIn(300);
						$(cmp.wizardCircle[cmp.wizardCurrent]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent]).removeClass('_current');
						$(cmp.wizardCircle[cmp.wizardCurrent+1]).addClass('_current');
						cmp.wizardCurrent++;
						cmp.wizardAnswer += 'l';
					}
					else{
						$(cmp.wizardPage).hide();
						$(cmp.wizardPage[cmp.wizardCurrent+2]).fadeIn(300);
						$(cmp.wizardCircle[cmp.wizardCurrent]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent+1]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent]).removeClass('_current');
						$(cmp.wizardCircle[cmp.wizardCurrent+2]).addClass('_current');
						cmp.wizardCurrent += 2;
						cmp.wizardAnswer += 'r';
					}
					break;
				}
				case 1:{
					if($('#question2a').is(':checked')){
						$(cmp.wizardPage).hide();
						$(cmp.wizardPage[cmp.wizardCurrent+3]).fadeIn(300);
						$(cmp.wizardCircle[cmp.wizardCurrent]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent+1]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent+2]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent]).removeClass('_current');
						$(cmp.wizardCircle[cmp.wizardCurrent+3]).addClass('_current');
						cmp.wizardCurrent += 3;
						cmp.wizardAnswer += 'l';
					}
					else{
						$(cmp.wizardPage).hide();
						$(cmp.wizardPage[cmp.wizardCurrent+2]).fadeIn(300);
						$(cmp.wizardCircle[cmp.wizardCurrent]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent+1]).addClass('_answered');
						$(cmp.wizardCircle[cmp.wizardCurrent]).removeClass('_current');
						$(cmp.wizardCircle[cmp.wizardCurrent+2]).addClass('_current');
						cmp.wizardCurrent += 2;
						cmp.wizardAnswer += 'r';
					}
					break;
				}
				case 2:{
					if($('#question3d').is(':checked')){
						cmp.wizardDiscount = true;
						cmp.wizardAnswer += 'l';
					}
					else{
						cmp.wizardAnswer += 'r';
					}
					$(cmp.wizardPage).hide();
					$(cmp.wizardPage[cmp.wizardCurrent+2]).fadeIn(300);
					$(cmp.wizardCircle[cmp.wizardCurrent]).addClass('_answered');
					$(cmp.wizardCircle[cmp.wizardCurrent+1]).addClass('_answered');
					$(cmp.wizardCircle[cmp.wizardCurrent]).removeClass('_current');
					$(cmp.wizardCircle[cmp.wizardCurrent+2]).addClass('_current');
					cmp.wizardCurrent += 2;
					break;
				}
				case 3:{
					if($('#question4d').is(':checked')){
						cmp.wizardAnswer += 'r';
					}
					else{
						cmp.wizardAnswer += 'l';
					}
					$(cmp.wizardPage).hide();
					$(cmp.wizardPage[cmp.wizardCurrent+1]).fadeIn(300);
					$(cmp.wizardCircle[cmp.wizardCurrent]).addClass('_answered');
					$(cmp.wizardCircle[cmp.wizardCurrent]).removeClass('_current');
					$(cmp.wizardCircle[cmp.wizardCurrent+1]).addClass('_current');
					cmp.wizardCurrent++;
					break;
				}
				case 4:{
					if($('#question5a').is(':checked')){
						cmp.wizardAnswer += 'l';
					}
					else{
						cmp.wizardAnswer += 'r';
					}
					switch(cmp.wizardAnswer){
						case 'lll':{
							$('#chooseHome').show();
							break;
						}
						case 'llr':{
							$('#chooseHomePortable').show();
							break;
						}
						case 'lrll':{
							$('#chooseBusiness').show();
							break;
						}
						case 'lrlr':{
							$('#chooseBusinessPortable').show();
							break;
						}
						case 'lrrl':{
							$('#chooseAction').show();
							break;
						}
						case 'lrrr':{
							$('#chooseActionPortable').show();
							break;
						}
						case 'rll':{
							$('#chooseAction').show();
							break;
						}
						case 'rlr':{
							$('#chooseActionPortable').show();
							break;
						}
						case 'rrl':{
							$('#chooseBusiness').show();
							break;
						}
						case 'rrr':{
							$('#chooseBusinessPortable').show();
							break;
						}
					}

					$('.js-wizard-questions').hide();
					$('.js-wizard-answer').show();
					break;
				}
			}
		}
	});

	cmp.wizardVat.on('click', function(e) {
		e.preventDefault();

		$('.js-wizard-answer').hide();
		$('.js-wizard-vat').show();
	});

	cmp.wizardVatClose.on('click', function(e) {
		e.preventDefault();

		$('.js-wizard-vat').hide();
		$('.js-wizard-answer').show();
	});

};

$(document).ready(function(){

	$('.js-wizard-trigger').magnificPopup({
		type: 'ajax',
		closeBtnInside: 'true',
		callbacks: {
			ajaxContentAdded: function () {
				// Ajax content is loaded and appended to DOM
				$('.js-wizard').each(function(){
					new Wizard(this);
				});

				// Ajax content is loaded and appended to DOM
				$.ajax({
					type: "GET",
					url: "/vat/?popup=1",
					dataType: "html",
					cache: false,
					success: function( html ){
						$(".js-wizard-vat").append( html );
					}
				});

				$('.js-tooltip').each(function(){
					new Tooltips(this);
				});
			}
		}
	});
});